import { DefaultIconProps } from './types';
import { LOADER_ICON_URL } from './urls';

export const LoaderIcon = ({ className, ...props }: DefaultIconProps) => (
  <img
    className={className}
    src={LOADER_ICON_URL}
    alt="loader"
    {...props}
  />
);
